<template>
  <modal name="noticiaCreate" height="auto" width="900" :scrollable="true" :clickToClose="true">
    <div class="modalbox">
      <div class="content">
        <div class="row">
          <ul class="tabs">
            <li class="tab-active">
              <a>Novo Aviso</a>
            </li>
          </ul>
        </div>
        <div class="form">
          <div class="row">
            <div class="col-1">
              <div class="form-group">
                <label for>Título</label>
                <input type="text" v-model="titulo" class="form-control">
                <div class="message">{{ validation.firstError('titulo') }}</div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-1">
              <div class="form-group">
                <label for>Resumo</label>
                <input type="text" v-model="resumo" class="form-control">
                <div class="message">{{ validation.firstError('resumo') }}</div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-1-2">
              <div class="form-group">
                <label for>Público Alvo</label>
                <select v-model="publico" class="form-control">
                  <option value>Selecione</option>
                  <option value="publico">Público</option>
                  <option value="callcenter">Call Center</option>
                  <option value="representantes">Representantes</option>
                  <option value="cliente">Cliente</option>
                  <option value="colaborador">Colaborador</option>
                  <option value="supervisor">Supervisor</option>
                  <option value="todos">Todos</option>
                </select>
                <div class="message">{{ validation.firstError('publico') }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="form-actions">
            <button class="button button-success button-lg" v-on:click="handleSubmit">Inserir</button>
            <button class="button button-lg" v-on:click="handleClose">Fechar</button>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>
<script>
import { Validator } from "simple-vue-validator";

export default {
  name: "noticiaCreate",
  props: ["create", "close"],
  data() {
    return {
      titulo: "",
      resumo: "",
      publico: ""
    };
  },
  validators: {
    titulo: value => Validator.value(value).required(),
    resumo: value => Validator.value(value).required(),
    publico: value => Validator.value(value).required()
  },
  methods: {
    handleClose() {
      this.titulo = "";
      this.resumo = "";
      this.publico = "";
      this.close();
    },
    handleSubmit() {
      this.$validate().then(success => {
        if (success) {
          this.create(this.titulo, this.resumo, this.publico);
          this.handleClose();
        }
      });
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/views/Noticias/Create.vue